// Shared document-type list — mirrors backend DOCUMENT_TYPES in server.py
// exactly (same order). Upload & Extract's upload zones and the Vault
// "Process in Tax App" modal both derive from this single source of truth.
export const DOCUMENT_TYPES = [
  "Bank Statement",
  "CACFP Report",
  "Subsidy/1099 Report",
  "Utility Bill",
  "Receipt/Invoice",
  "Payroll Report",
  "Health Insurance",
  "Auto Insurance",
  "Business Insurance",
  "Real Estate Taxes",
  "Maintenance & Repairs",
  "Other Income",
  "Food Purchases",
  "Phone & Internet",
  "Credit Card Statement",
  "Vehicle Expense",
  "Manual Entry / Cash Transactions",
  "Misc Upload",
  "Grant Documents",
  "Equipment Receipts",
];

// Offered when picking a type for an actual uploaded FILE (e.g. the Vault
// processing modal) — excludes "Manual Entry / Cash Transactions", which
// has no associated file.
export const DOCUMENT_TYPES_FOR_FILE = DOCUMENT_TYPES.filter(
  (t) => t !== "Manual Entry / Cash Transactions"
);
